import { render } from "./tableadmin.vue?vue&type=template&id=5f4a2a0b"
import script from "./tableadmin.vue?vue&type=script&lang=js"
export * from "./tableadmin.vue?vue&type=script&lang=js"

import "./tableadmin.vue?vue&type=style&index=0&id=5f4a2a0b&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__